import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Offcanvas from '../components/Offcanvas';
import SearchArea from '../components/SearchArea';
import Tours from '../components/Tours';
import BreadcrumbSection from '../components/BreadcrumbSection';
import { API_BASE_URL } from '../config/config.js'; 

function TourDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get('category');
  const value = queryParams.get('value');
  const [tourData, setTourData] = useState([]);

  useEffect(() => {
    const fetchTourDetails = async () => {
      try {
        let apiUrl = '';
        switch (category) {
          case 'destination':
            apiUrl = `${API_BASE_URL}/api/v1/destinations/${value}`;
            break;
          case 'themed-holidays':
            apiUrl = `${API_BASE_URL}/api/v1/themed-holidays/${value}`;
            break;
          case 'local-packages':
            apiUrl = `${API_BASE_URL}/api/v1/local-packages/${value}`;
            break;
          case 'safari-packages':
            apiUrl = `${API_BASE_URL}/api/v1/tour-packages/${value}`;
            break;
          default:
            apiUrl = '';
        }

        if (apiUrl) {
          console.log(`Fetching tour details from ${apiUrl}...`);
          const response = await fetch(apiUrl);
          const data = await response.json();
          console.log("Raw tour details API response:", data);

          // Normalize the response based on category
          let normalizedData = [];
          if ((category === 'themed-holidays' || category === 'local-packages' || category === 'destination') && data.data.tour_packages) {
            normalizedData = data.data.tour_packages.map((item, index) => ({
              id: item.id || index + 1,
              title: item.name,
              category: item.category,
              value: item.slug,
              destinations: [item.destination || 'Unknown'],
              price: parseFloat(item.base_price) || 0,
              duration: `${item.days} days / ${item.nights} nights`,
              image: item.image || (item.images?.[0] ? `${API_BASE_URL}/storage/${item.images[0]}` : './assets/img/header/home-2.jpg'),
              average_rating: item.average_rating || 'N/A',
            }));
          } else if (Array.isArray(data.data)) {
            normalizedData = data.data.map((item, index) => ({
              id: item.id || index + 1,
              title: item.title || item.name,
              category: item.category || category,
              value: item.value || item.slug,
              destinations: item.destinations || [item.country || item.destination || 'Unknown'],
              price: parseFloat(item.price || item.base_price) || 0,
              duration: item.duration || 'N/A',
              image: item.image || item.images?.[0] ? `${API_BASE_URL}/storage/${item.images[0]}` : './assets/img/header/home-2.jpg',
              average_rating: item.average_rating || item.overall_rating || 'N/A',
            }));
          } else if (data.data) {
            normalizedData = [{
              id: data.data.id || Date.now(),
              title: data.data.title || data.data.name,
              category,
              value: data.data.value || data.data.slug,
              destinations: data.data.destinations || [data.data.country || data.data.destination || 'Unknown'],
              price: parseFloat(data.data.price || data.data.base_price) || 0,
              duration: data.data.duration || 'N/A',
              image: data.data.image || data.data.images?.[0] ? `${API_BASE_URL}/storage/${data.data.images[0]}` : './assets/img/header/home-2.jpg',
              average_rating: data.data.average_rating || data.data.overall_rating || 'N/A',
            }];
          }

          setTourData(normalizedData);
          console.log("Normalized tour data:", normalizedData);
        }
      } catch (error) {
        console.error("Error fetching tour details:", error);
      }
    };

    fetchTourDetails();
  }, [category, value]);

  return (
    <>
      <Offcanvas />
      <SearchArea />
      <Header />
      <BreadcrumbSection />
      <Tours tours={tourData} />
      <Footer />
    </>
  );
}

export default TourDetails;